import React from "react";
import style from "./EmptyState.module.css";
import EmptyIcon from "../../assets/icons/empty.svg";
import Button from "../Button/Button";

const EmptyState = ({text, btnText, handleBtn}) => {
  return (
    <div className={style.emptyState}>
      <img src={EmptyIcon} alt="emptyIcon" />
      <h6>{text}</h6>
      <Button
        className={style.addBtn}
        text={btnText}
        onClick={() => handleBtn()}
      ></Button>
    </div>
  );
};

export default EmptyState;
